export default "__VITE_ASSET__4f2234a1__"